import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Button,
  Heading,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AssociateAccountSuccess = ({
  login,
  onClose,
}) => (
  <>
    <Heading level={1}>
      <I18n path="settings.numberManagement.associatingAccount.linkingSuccess" />
    </Heading>
    <Heading className={cx('subtitle')} level={5}>
      <I18n
        path="settings.numberManagement.associatingAccount.linkingAccountSuccess"
        vars={{ login }}
      />
    </Heading>
    <Button
      className="big"
      onClick={onClose}
    >
      <I18n path="common.continueWorking" />
    </Button>
  </>
);

AssociateAccountSuccess.propTypes = {
  login: PropTypes.string,
  onClose: PropTypes.func,
};

export default AssociateAccountSuccess;
